import { createContext, useContext, useState } from "react";

// إنشاء Context جديد
const StoreContext = createContext();

// إنشاء Provider لإدارة الحالة
export const StoreProvider = ({ children }) => {
    const [isSearch, setIsSearch] = useState(false);
    const [isBannedUser, setIsBannedUser] = useState(false);

    return (
        <StoreContext.Provider value={{ isSearch, setIsSearch, isBannedUser, setIsBannedUser }}>
            {children}
        </StoreContext.Provider>
    );
};

// إنشاء hook لاستهلاك الـ Context
export const useStore = () => useContext(StoreContext);
